<template>
	<div>
		<div>
			<button class="btn btn-dark" type="button" data-toggle="collapse" data-target="#collapseGuide" aria-expanded="false" aria-controls="collapseGuide">
				Hướng dẫn
			</button>
		</div>
		<div class="collapse" id="collapseGuide">
			<div class="card card-body bg-dark text-light">
				<h2>App xếp Lịch học HUST</h2>
				B1) Upload TKB dự kiến<br>
				B2) Nhập các mã học phần, chọn đúng chương trình học<br>
				B3) Nhấn "Tìm lớp"<br>
				B4) Kéo thả các mã học phần vào bảng<br>
				B5)<br>
				Nhấn "Xong" để lấy các mã lớp và cố định TKB<br>
				Hoặc nhấn "Xuất file" để lưu TKB đã xếp dưới dạng excel (về sau có thể import lại và sửa tiếp)<br>
				Hoặc nhấn "Lưu trong Browser" để khi load lại trang, chỉ cần nhấn "Import TKB" và "Nhập từ lưu trữ" là hiện ra TKB đã lưu<br>
				<br>
				<b>Video:</b>
				<a href="https://youtu.be/rnzjtvPspZE" target="_blank">Hướng dẫn</a>
				<br>
				<h3>Tính năng:</h3>
				+Trong bảng, di chuột vào tên lớp để xem chi tiết về lớp<br>
				<div>+Nhấn <i class="fas fa-chevron-circle-down"></i> bên cạnh tên học phần để xem chi tiết các lớp của học phần</div>
				<div>+Nhấn <i class="fas fa-info-circle d-inline"></i> bên cạnh mã lớp và ngày giờ để xem chi tiết lớp</div>
				+"Import TKB" để nhập TKB đã xuất ra file excel<br>
				<br><br>
				<h4>Lưu ý:</h4>
				+Nhấn "Xong" sẽ không thể thay đổi thời khóa biểu hay nhập thêm mã học phần<br>
				+Chưa có tính năng tự động thêm vào bảng những lớp kèm hay lớp cùng mã nhưng khác ngày<br>
				+Có những lớp chồng lên nhau do cùng mã HP, thời gian nhưng khác chương trình hoặc mã lớp.<br>
				VD: (BT, BT, LT, TN) Vật lý đại cương => 4 lớp cùng mã HP, cùng thời gian nhưng khác mã lớp, khác phòng<br>
				<br>
				<!-- <h5>Nâng cao</h5>
				<small>
					*TKB dự kiến do người dùng soạn nên có thể có thay đổi về font chữ, tiêu đề, tên cột,...
					Nếu bạn không thể sử dụng được App, có lẽ copy tên các cột cho giống với TKB dự kiến sẽ khắc phục vấn đề.
					<br>
					Thời gian phải theo định dạng 0645-0930, nếu không App sẽ không dùng được
				</small>
				<button @click="toggleChangeTitle()" class="btn btn-primary" style="width: fit-content;">
					{{ changeTitle ? 'Lưu' : 'Sửa' }}
				</button>
				<div class="row">
					<div class="col-12 col-md-3" v-for="key in Object.keys(titleTrans)" :key="key">
						<input v-model="titleTrans[key]" :disabled="!changeTitle" />
					</div>
				</div> -->
			</div>
		</div>
		<div class="row my-5">
			<h4 class="col-12">Có thể bạn quan tâm:</h4>
			<div class="col-12">
				<router-link to="/drl" :target="isTableVisible ? '_blank' : ''"><i class="fas fa-calendar-alt mr-2"></i>App xếp Điểm rèn luyện</router-link>
			</div>
			<div class="col-12">
				<a href="https://www.facebook.com/groups/hotrosinhvienontapdaicuong/permalink/915162249162809/" :target="isTableVisible ? '_blank' : ''">
					<i class="fab fa-facebook mr-1"></i>Feedback của Người dùng
				</a>
			</div>
			<div class="col-12">
				<a href="https://www.facebook.com/hieupham19072001/" :target="isTableVisible ? '_blank' : ''"><i class="fab fa-facebook mr-1"></i>Phạm Trung Hiếu ?</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['isTableVisible']
}
</script>